import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Auth } from '@aws-amplify/auth';
import { OktaRestriction } from 'src/app/core/services/okta-restrictions.service';

@Injectable({
  providedIn: 'root'
})
export class OktaAuthGuardService {
  constructor(
    private router: Router,
    private restrictionService: OktaRestriction
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return Auth.currentAuthenticatedUser()
      .then(() => {
        const allowed = this.hasAccess(route);

        if (!allowed) {
          this.router.navigate(['/login']);
        }

        return allowed;
      })
      .catch(() => {
        this.router.navigate(['/login']);
        return false;
      });
  }

  private hasAccess(route: ActivatedRouteSnapshot): boolean {
    const firstSegment = route.url[0]?.path;

    if (firstSegment === 'qa-testing') {
      return !!this.restrictionService.qa_permission;
    }

    if (firstSegment === 'drb') {
      return !!(this.restrictionService.drb_manager_permission || this.restrictionService.drb_user_permission);
    }

    return false;
  }
}
